import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_supplemental_fees_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { billingContractLineId: number, billingContractId?: number }): 
  Promise<{ result: { Id?: number, BillingCodeId?: number, BillingContractLineId?: number, Rate?: number, Value?: number, ValueIsPercentage?: boolean, BillingCode?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.billingContractLineId)) {
      missingRequiredInParams.push('\'billingContractLineId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_supplemental_fees_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { billingContractLineId: number, billingContractId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, BillingCodeId?: number, BillingContractLineId?: number, Rate?: number, Value?: number, ValueIsPercentage?: boolean, BillingCode?: { Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.billingContractLineId)) {
      missingRequiredInParams.push('\'billingContractLineId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_supplemental_fees_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { billingContractLineId: number, billingContractId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, BillingCodeId?: number, BillingContractLineId?: number, Rate?: number, Value?: number, ValueIsPercentage?: boolean, BillingCode?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.billingContractLineId)) {
      missingRequiredInParams.push('\'billingContractLineId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_billing_supplemental_fees_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
